import React, { createContext, useContext, ReactNode } from 'react';

interface MaintenanceContextType {
  isInMaintenance: boolean;
  maintenanceMessage: string;
}

const MaintenanceContext = createContext<MaintenanceContextType | undefined>(undefined);

const useMaintenanceContext = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error('useMaintenanceContext must be used within a MaintenanceProvider');
  }
  return context;
};

interface MaintenanceProviderProps {
  children: ReactNode;
}

const MaintenanceProvider: React.FC<MaintenanceProviderProps> = ({ children }) => {
  // Read directly from environment variables - no state needed
  const isInMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const maintenanceMessage = process.env.REACT_APP_MAINTENANCE_MESSAGE || 'System is under maintenance. Please check back soon.';

  return (
    <MaintenanceContext.Provider value={{ isInMaintenance, maintenanceMessage }}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export { MaintenanceProvider, useMaintenanceContext };
export default MaintenanceProvider; 